// @flow
import type {Node} from 'react';
import type {Parcel} from 'react-dataparcels';
import type {ConfigFields} from 'bfu-auth-client/src/login/data/Config.js';

import React from 'react';
import ParcelBoundary from 'react-dataparcels/ParcelBoundary';

import Input from 'react-goose/lib/Input';
import Label from 'react-goose/lib/Label';

import InvalidField from 'bfu-auth-client/src/login/appliance/InvalidField.jsx';

const onlyDigits = parcel => parcel.modifyUp(value => value.replace(/[\D]/g, ''));

type Props = {
    parcel: Parcel,
    fieldsConfig: ConfigFields
};

export const UsernameField = (props: Props): Node => {
    let {parcel, fieldsConfig} = props;
    return <ParcelBoundary parcel={parcel} debounce={200}>
        {(parcel) => <>
            <Label spruceName="BlueflagAuthFormLabel">{fieldsConfig.usernameLabel}</Label>
            <Input
                spruceName="BlueflagAuthFormInput"
                modifier="text"
                placeholder={fieldsConfig.usernamePlaceholder}
                name="username"
                {...parcel.spread()}
            />
            <InvalidField parcel={parcel} />
        </>}
    </ParcelBoundary>;
};

export const PasswordField = (props: Props): Node => {
    let {parcel, fieldsConfig} = props;
    return <ParcelBoundary parcel={parcel} debounce={200}>
        {(parcel) => <>
            <Label spruceName="BlueflagAuthFormLabel">{fieldsConfig.passwordLabel}</Label>
            <Input
                spruceName="BlueflagAuthFormInput"
                modifier="text"
                placeholder={fieldsConfig.passwordPlaceholder}
                type="password"
                name="password"
                inputProps={{autoComplete: 'password'}}
                {...parcel.spread()}
            />
            <InvalidField parcel={parcel} />
        </>}
    </ParcelBoundary>;
};

export const ChooseUsernameField = (props: Props): Node => {
    let {parcel, fieldsConfig} = props;
    return <ParcelBoundary parcel={parcel} debounce={200}>
        {(parcel) => <>
            <Label spruceName="BlueflagAuthFormLabel">{fieldsConfig.chooseUsernameLabel}</Label>
            <Input
                spruceName="BlueflagAuthFormInput"
                modifier="text"
                placeholder={fieldsConfig.chooseUsernamePlaceholder}
                name="username"
                {...parcel.spread()}
            />
            <InvalidField parcel={parcel} />
        </>}
    </ParcelBoundary>;
};

export const ChoosePasswordField = (props: Props): Node => {
    let {parcel, fieldsConfig} = props;
    return <ParcelBoundary parcel={parcel} debounce={200}>
        {(parcel) => <>
            <Label spruceName="BlueflagAuthFormLabel">{fieldsConfig.choosePasswordLabel}</Label>
            <Input
                spruceName="BlueflagAuthFormInput"
                modifier="text"
                placeholder={fieldsConfig.choosePasswordPlaceholder}
                type="password"
                name="password"
                inputProps={{autoComplete: 'password'}}
                {...parcel.spread()}
            />
            <InvalidField parcel={parcel} />
        </>}
    </ParcelBoundary>;
};

export const ChoosePasswordConfirmField = (props: Props): Node => {
    let {parcel, fieldsConfig} = props;
    return <ParcelBoundary parcel={parcel} debounce={200}>
        {(parcel) => <>
            <Label spruceName="BlueflagAuthFormLabel">{fieldsConfig.choosePasswordConfirmLabel}</Label>
            <Input
                spruceName="BlueflagAuthFormInput"
                modifier="text"
                placeholder={fieldsConfig.choosePasswordConfirmPlaceholder}
                type="password"
                name="password"
                inputProps={{autoComplete: 'password'}}
                {...parcel.spread()}
            />
            <InvalidField parcel={parcel} />
        </>}
    </ParcelBoundary>;
};

export const VerificationCodeField = (props: Props): Node => {
    let {parcel, fieldsConfig} = props;
    return <ParcelBoundary parcel={parcel.pipe(onlyDigits)} debounce={200}>
        {(parcel) => <>
            <Label spruceName="BlueflagAuthFormLabel">{fieldsConfig.verificationCodeLabel}</Label>
            <Input
                spruceName="BlueflagAuthFormInput"
                modifier="text"
                placeholder={fieldsConfig.verificationCodePlaceholder}
                name="verificationCode"
                {...parcel.spread()}
            />
            <InvalidField parcel={parcel} />
        </>}
    </ParcelBoundary>;
};

export const EmailField = (props: Props): Node => {
    let {parcel, fieldsConfig} = props;
    return <ParcelBoundary parcel={parcel} debounce={200}>
        {(parcel) => <>
            <Label spruceName="BlueflagAuthFormLabel">{fieldsConfig.emailLabel}</Label>
            <Input
                spruceName="BlueflagAuthFormInput"
                modifier="text"
                placeholder={fieldsConfig.emailPlaceholder}
                type="email"
                name="email"
                {...parcel.spread()}
            />
            <InvalidField parcel={parcel} />
        </>}
    </ParcelBoundary>;
};
